module.exports = __webpack_public_path__ + "components/flag/static/square/kw-32c265bdc9679d3899ef846a6f55bf13.svg";